/** 보고서 인적사항 최소화 (지도감독 원칙 1, A30) */
/** 기관·학교·학과·교회 이름 가리기: ○○대학교 대학원 ○○과 석사과정 (과정은 남김) */
export function maskInstitutions(text: string): string {
  return text
    .replace(/[가-힣A-Za-z]{1,15}(대학교|대학원대학교|신학대학교|여자대학교)/g, (m, kind: string) =>
      m.startsWith('○○') ? m : `○○${kind}`,
    )
    // "가나대 경영학과" 같은 줄임: 학과·전공 앞의 "○대"는 학교 이름만 가린다
    .replace(
      /(^|[\s(,])[가-힣]{1,12}대(?=\s*[가-힣]{0,12}(학과|과|학부|전공))/g,
      (m, pre: string) => (m.trim().startsWith('○○') ? m : `${pre}○○대`),
    )
    .replace(/(대학원\s*)[가-힣]{1,15}(학과|과|전공)/g, '$1○○$2')
    .replace(/[가-힣]{1,15}(교회|성당)(?=[\s,.)]|$)/g, (m, kind: string) => (m.startsWith('○○') ? m : `○○${kind}`));
}
